import { Autocomplete, Box, Button, Drawer, Grow, Stack, TextField, Tooltip, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import '../reports.css';
import { AmountsCard } from '../../../../Components/CommonCards/CommonCards'
import { ImagePaths } from '../../../../Utility/ImagePaths';
import CommonDatePicker from '../../../../Components/Common Components/CommonDatePicker';
import { CommonGridToolBarWithFilterText, CommonPatientDetails, CommonTimeRangePicker } from "../../../../Components/Common Components/CommonComponents";
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { DateTime } from 'luxon';
import { formatDate, timeOnlyConvert, Time_convert, formatDateAndTimeMeth2, CheckAccessFunc } from '../../../../Components/CommonFunctions/CommonFunctions';
import { Colors } from '../../../../Styles/Colors';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';

class AppointmentRequestReport extends Component {
    constructor(props) {
        super(props)
        this.state = {
            appointmentRequestReportData: [],
            page: 0,
            pageSize: 10,
            fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            doctorName: [],
            specialization: [],
            appointmentType: [],
            startDate: null,
            dateIndex: 1,
            appointmentDoctors: null,
            appointmentTotalAmount: null,
            appointmentTotalPatient: null,
            appointmentTypeList: [],
            doctorNameList: [],
            specializationList: [],
            appointmentReqCardList: [],
            FilteredFromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            FilteredToDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            PatientsCount: null,
            PatientsAmount: null,
            showBox: false,
            patientType: [],
            FilterDatas: {
                "startTime": null,
                "endTime": null,
                "onError": false,
            },
            timeError: false,
            status: [
                { name: 'Approved', value: '2' },
                { name: 'Cancelled', value: '3' },
                { name: 'No Show', value: '1' },
            ],
            SelectedStatusType:[]
        }
    }

    componentDidMount() {
        let editAccess = CheckAccessFunc("front_office", "Reports", "Appointment Reports", "Appointment Request Report", "SubTab")?.editAccess
        this.setState({
            userEditAccess: editAccess
        }, () => {
            this.getAppointmentRequestData()
            this.getAppointmentTypeList()
            this.getDoctorNameList()
            this.getSpecializationList()
        })
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    onChangeHandler = (e) => {
        const { name, value } = e.target
        this.setState({
            [name]: value
        })
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    FilterDate = (from, to, index) => {
        this.setState({
            fromDate: from,
            toDate: to,
            dateIndex: index
        }, () => {
            this.state.FilterDatas.endTime = null
            this.setState({
                FilterDatas: this.state.FilterDatas
            })
        })
    }

    getAppointmentRequestData = () => {
        try {
            this.LoaderFunction(true)
            let doctorId = []; let specializationId = []; let statusType = [];
            this.state.doctorName.forEach(element => doctorId.push(element.doctor_id))
            this.state.specialization.forEach(element => specializationId.push(element.id))
            this.state.SelectedStatusType.forEach(element => statusType.push(element.value))
            RestAPIService.getAll(Serviceurls.FO_REPORTS_REQUEST_APPOINTMENT + `?from_date=${this.state.fromDate}&to_date=${this.state.toDate}&doctor_id=${doctorId}&speciality_id=${specializationId}&status=${statusType}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.setState({
                            appointmentRequestReportData: response.data?.data,
                            appointmentTotalPatient: response.data.count_data?.total_count,
                            FilteredFromDate: this.state.fromDate,
                            FilteredToDate: this.state.toDate,
                            PatientsCount: response.data?.count_data
                        }, () => { this.LoaderFunction(false) })
                    }
                }).catch((error) => {
                    this.LoaderFunction(false)
                    if (error?.response?.data?.status === 'fail') {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.LoaderFunction(false)
            this.errorMessage(error.message)
        }
    }
    printReports = () => {
        try {
            let doctorId = []; let specializationId = []; let statusType = [];
            this.state.doctorName.forEach(element => doctorId.push(element.doctor_id))
            this.state.specialization.forEach(element => specializationId.push(element.id))
            this.state.SelectedStatusType.forEach(element => statusType.push(element.value))
            RestAPIService.getAll(Serviceurls.FO_REPORTS_REQUEST_APPOINTMENT + `?from_date=${this.state.fromDate}&to_date=${this.state.toDate}&doctor_id=${doctorId}&speciality_id=${specializationId}&status=${statusType}&export_type=pdf`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    this.errorMessage(error.message)
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }
    getDoctorNameList = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            doctorNameList: response.data.data
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === 'fail') {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    getAppointmentTypeList = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPAPPOINTMENT)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            appointmentTypeList: response.data.data
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === 'fail') {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    getSpecializationList = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPSPECIALIZATION)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            specializationList: response.data.data
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === 'fail') {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    convertTo12Hour(time) {
        const [hour, minute] = time.split(':').map(Number);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        const hour12 = hour % 12 || 12; // Converts "0" hour to "12"
        return `${hour12}:${minute.toString().padStart(2, '0')} ${ampm}`;
      }

    selectedTime = (start, end, error) => {
        this.state.FilterDatas.startTime = start
        this.state.FilterDatas.endTime = end
        this.setState({ FilterDatas: this.state.FilterDatas, timeError: error })
    }

    renderFilterScreen = () => {
        const { t } = this.props
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{t("Filter")}</Typography>
                    <Button onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_date_filter'>
                        <CommonDatePicker
                            FromDate={this.state.fromDate}
                            ToDate={this.state.toDate}
                            DateIndex={this.state.dateIndex}
                            SelectedDates={this.FilterDate.bind(this)}
                            Future={true}
                            HideAllMenu={true} />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            multiple
                            limitTags={1}
                            size='small'
                            options={this.state.doctorNameList?.map((item) => item)}
                            getOptionLabel={(option) => (option?.doctor_name)}
                            value={this.state.doctorName}
                            onChange={(event, newValue) => {
                                this.setState({ doctorName: newValue })
                            }}
                            renderOption={(props, option) => (
                                <li {...props} key={option?.doctor_id}>
                                    {option?.doctor_name}
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t('selectDoctor')}
                                />
                            )}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            multiple
                            limitTags={1}
                            size='small'
                            options={this.state.specializationList?.map((item) => item)}
                            getOptionLabel={(option) => (option?.name)}
                            value={this.state.specialization}
                            onChange={(event, newValue) => {
                                this.setState({ specialization: newValue })
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t('selectSpecial')}
                                />
                            )}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            multiple
                            limitTags={1}
                            size='small'
                            options={this.state.status?.map((item) => item)}
                            getOptionLabel={(option) => (option?.name)}
                            value={this.state.SelectedStatusType}
                            onChange={(event, newValue) => {
                                this.setState({ SelectedStatusType: newValue })
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t('Select Status')}
                                />
                            )}
                        />
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"
                        onClick={() => {
                            this.setState({
                                doctorName: [], startDate: null, SelectedStatusType: [],
                                specialization: [], appointmentType: [], patientType: [],
                                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                dateIndex: 1,
                                FilterDatas: {
                                    "startTime": null,
                                    "endTime": null,
                                    "onError": false
                                },
                                timeError: false,
                            }, () => this.getAppointmentRequestData())
                        }}
                        id="eMed_Config_btn">{t("Clear")}</Button>
                    <Button variant='contained' size="small"
                        disabled={this.state.FilterDatas.startTime ? (this.state.FilterDatas.startTime && this.state.FilterDatas.endTime && this.state.timeError != true) ? false : true : false}
                        onClick={() => {
                            this.getAppointmentRequestData()
                            this.setState({ FilterOpen: false })
                        }}
                        id="eMed_Config_btn">{t("Search")}</Button>
                </Stack>
            </Box>
        )
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
        })
    }

    gridToolBar = () => {
        let TextArray = [
            { label: "From Date", value: formatDate(this.state.FilteredFromDate) },
            { label: "To Date", value: formatDate(this.state.FilteredToDate) },
        ]
        return (
            <Box>
                <CommonGridToolBarWithFilterText FilterTextArray={TextArray} />
            </Box>

        )
    }

    render() {

        this.state.appointmentRequestReportData?.forEach((element, index) => element.sno = index + 1)
        const { t } = this.props
        const columns = [
            {
                field: "patient_name", headerName: t("PatientName"), flex: 0.178,
                renderCell: (params) => (<CommonPatientDetails data={params?.row} showDetailed={true} />), valueGetter: (params) => {
                    const name = params.row?.patient_name || "";
                    const mobile = params.row?.mobile_no || "";
                    const UHID = params.row?.uhid || "";
                    return `${name} ${mobile} ${UHID}`;
                }
            },
            {
                field: "doctor_name", headerName: t("DoctorName"), flex: 0.142,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.doctor_name && CommonValidation.removeSpace(params?.row?.doctor_name) !== "" ? params?.row?.doctor_name?.length > 20 ?
                    <div><Tooltip placement='top' title={params?.row?.doctor_name} arrow><div>{params?.row?.doctor_name.slice(0, 20) + "..."}</div></Tooltip></div> : params?.row?.doctor_name : "-"}</Box>)
            },
            {
                field: "specialization", headerName: t("Specialization"), flex: 0.142,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.specialization ?params?.row?.specialization?.length > 20 ?
                    <div><Tooltip placement='top' title={params?.row?.specialization} arrow><div>{params?.row?.specialization.slice(0, 20) + "..."}</div></Tooltip></div> : params?.row?.specialization : "-"}</Box>)
            },
            {
                field: "appointment_type", headerName: t("AppointmentType"), flex: 0.142,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.appointment_type ? params?.row?.appointment_type?.length > 20 ?
                    <div><Tooltip placement='top' title={params?.row?.appointment_type} arrow><div>{params?.row?.appointment_type.slice(0, 20) + "..."}</div></Tooltip></div> : params?.row?.appointment_type : "-"}</Box>)
            },
            {
                field: "request_date", headerName: t("Requested Date & Time"), flex: 0.142, align: "center", headerAlign: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.created_date ? formatDateAndTimeMeth2(params?.row?.created_date) : "-"}</Box>)
            },
            {
                field: "appointment_date", headerName: t("Appointment Date & Time"), flex: 0.142, align: "center", headerAlign: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.appointment_date ? `${params?.row?.appointment_date ? params?.row?.appointment_date.split("-").reverse().join("-") : "-" } | ${params?.row?.appointment_time ? this.convertTo12Hour(params?.row?.appointment_time) : "-"}`  : "-"}</Box>)
            },
            {
                field: "status", headerName: t("Status"), flex: 0.106, align: "center", headerAlign: "center",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.status ? params?.row?.status : "-"}</Box>)
            }
        ]
        return (
            <Box component={'div'} className='eMed_rts_container'>
                <Box component={"div"} className='eMed_Top_Container'>
                    <Box component={"div"} className='eMed_Cards_Container'>
                        <Button className='eMed_Recpt_header_amt_card' onClick={() => { this.setState({ showBox: !this.state.showBox }) }}>
                            {AmountsCard(t("Total Request"), this.state.appointmentTotalPatient, true, this.state.showBox ? Colors.Primary : "white", true, this.state.showBox ? "white" : Colors.Primary)}
                        </Button>
                        <Box component={'div'} sx={{ width: '50vw', overflow: 'scroll', marginLeft: '1vw', height: "5.5vw", display: 'flex', alignItems: 'center' }} >
                            {this.state.showBox ?
                                <Box sx={{ display: 'flex', flexDirection: "row" }}>
                                    <Grow in={this.state.showBox} style={{ transformOrigin: '0 0 0' }}
                                        {...(this.state.showBox ? { timeout: 500 } : {})}>{AmountsCard(t("Approved Request"), this.state.PatientsCount?.converted_count, true)}</Grow>
                                    <Grow in={this.state.showBox} style={{ transformOrigin: '0 0 0' }}
                                        {...(this.state.showBox ? { timeout: 1000 } : {})}>{AmountsCard(t("Cancelled Request"), this.state.PatientsCount?.cancelled_count, true)}</Grow>
                                    <Grow in={this.state.showBox} style={{ transformOrigin: '0 0 0' }}
                                        {...(this.state.showBox ? { timeout: 1500 } : {})}>{AmountsCard(t("No Show Request"), this.state.PatientsCount?.no_show_count, true)}</Grow>
                                </Box> : null}
                        </Box>
                    </Box>
                    <Box component={"div"} className='eMed_Action_Container'>
                        <Box component={"div"} className='eMed_Filter_Icon_div'>
                            <Button className='eMed_usrconf_btn' onClick={() => { this.setState({ FilterOpen: true }) }}>
                                <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                            </Button>
                        </Box>
                        <Button className='eMed_usrconf_btn' onClick={() => { this.printReports() }}>
                            <img src={ImagePaths.LabPrintIcon.default} alt="print" className='eMed_action_img' />
                        </Button>
                        {/* <Button className='eMed_usrconf_btn'>
                            <img src={ImagePaths.LabUploadButton.default} alt="upload" className='eMed_action_img' />
                        </Button> */}
                    </Box>
                </Box>
                <Box component={'div'} className='eMed_rts_table'>
                    <DataGrid
                        rows={this.state.appointmentRequestReportData}
                        columns={columns}
                        getRowId={(row) => row.sno}
                        page={this.state.page}
                        pageSize={this.state.pageSize}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: this.gridToolBar,
                            NoRowsOverlay: () => (
                                <Stack className='eMed_conf_nodata'>
                                    {t("NoRecordsFound")}
                                </Stack>
                            )
                        }}
                        onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                        onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        headerHeight={40}
                        disableSelectionOnClick
                        loading={this.state.isLoader}
                    />
                </Box>
                <Drawer
                    anchor={'right'}
                    open={this.state.FilterOpen}
                    ModalProps={{ onBackdropClick: this.closeFilter }}
                >
                    {this.renderFilterScreen()}
                </Drawer>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
            </Box>
        )
    }
    closeFilter = () => {
        this.setState({ FilterOpen: false })
    }
}


export default withTranslation()(AppointmentRequestReport)
